(function () {
    'use strict';

    angular.module("imApp").factory("freightRateTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            listFreightRateTypes: function (parms) {
                return $ihttp.post({
                    method: 1536,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
